<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  extends: baseList,
  components: {
    baseList,
  },
  data() {
    return {
      table: {
        mname: "consumablesreceive",
        key: "id",
        url: {
          list: "/customer/customer/inventory/receiveList",
        },
        output: false,
        order: "receiveTime",
      },
      actions: [],
      menus: [],
      filters: [
        {
          label: "领用时间",
          KeyEnter: this.search,
          name: "receiveTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "领用科室",
          name: "desk",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
      ],
      exportdata: [],
      tableCols: [
        {
          title: "领用时间",
          width: 150,
          align: "center",
          key: "receiveTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "派送人",
          // minWidth: 180,
          align: "center",
          key: "maintainerName",
        },
        {
          title: "状态",
          // minWidth: 180,
          key: "state",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "已申请"
                : row.state === 2
                ? "派送中"
                : row.state === 3
                ? "已完成"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "完成时间",
          width: 150,
          align: "center",
          key: "finishTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.finishTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 100,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.handleEdit(currentRow)}
                  type="default"
                  style={{ margin: "4px 5px", border: "none", color: "#4991ff" }}
                >
                  详情
                </Button>
              );
            },
            // "delete",
          ],
          // auth: {
          //   del: "/admin/comment/del",
          // },
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    if (query.inventoryId) {
      this.query.inventoryId = query.inventoryId;
    }
    this.loadLevelData();
  },
  methods: {
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/customer/customer/desk/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.deskName;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "desk") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    // exportData(filename = '', is_all = 0) {
    //   this.$refs.tablelist.exportData(4, '', '领用记录表格', is_all)
    // },
    // toAdd() {
    //   $utils.url.push({ name: 'knowledgeBaseClass_add', query: { action: 'add' } })
    // },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "recordInfo_cus",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>
<style scoped></style>
